import * as React from 'react';
import { FormattedMessage  } from 'react-intl';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch, faBars, faChevronDown, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loading from '../loading/loading';

import './library.scss';

library.add(faSearch, faBars, faChevronDown, faArrowRight);

class Library extends React.Component  {
  render() {
    if(!this.props.state.isLoaded) {
      return (
        <Loading/>
      )
    } else {
      let tmpIssues = [];
      let baseUrl = this.props.state.baseUrl ? this.props.state.baseUrl : ".";
      let theBlock = this.props.state.loadedIssue.issueBlocks[0];

      if(this.props.state.issues){
        tmpIssues = this.props.state.issues.map((item, key) =>
        <div className="col-md-4 col-sm-6 flex-card">
          <div className="card mb-4">
              <div className="is-image"><img className="card-img-top " src={baseUrl+item.issueThumbnail} alt={item.issueTitle}></img></div>
              <div className="card-body">
                  <h5 className="card-title">{item.issueTitle}</h5>
                  <p className="card-text">{item.issueSummary}</p>
              </div>
              <div className="card-footer text-muted">
                  {item.issueExtLink &&
                    <a className='btn btn-link read-more' target={'_self'} href={item.issueExtLink}>
                        <span><FormattedMessage id="Library.read" defaultMessage="Read" /> {item.issueTitle}</span>
                        <span className="more-arrow"><FontAwesomeIcon icon="arrow-right" /></span>
                    </a>
                  } {!item.issueExtLink && 
                    <a className='btn btn-link read-more' onClick={() => {this.props.changeRoute(item.issueId, "")}} href={'./index.html?issueid='+item.issueId+"&lang="+this.props.state.locale}>
                        <span><FormattedMessage id="Library.read" defaultMessage="Read" /> {item.issueTitle}</span>
                        <span className="more-arrow"><FontAwesomeIcon icon="arrow-right" /></span>
                    </a>
                  }
              </div>
          </div>
        </div>
        );
      }

      return (
        <div id="app-library">
          <div className="container mb-5">
            <div className="row justify-content-center">
              <div className="col-md-6 col-sm-8 col-10">
                <h1><span className="pre-title"><FormattedMessage id="Library.title" defaultMessage="Welcome to" /></span><FormattedMessage id="Library.titleLineTwo" defaultMessage="Your Tomorrow, Today" /></h1>
                <div className="intro"><FormattedMessage id="Library.message" defaultMessage="Issues" /></div>
              </div>
            </div>
          </div>
          <div className="container mb-5">
            <div className="row sm-no-mar">
              <div className="col-md-6 col-lg-6 mt-5">
                  <div className="heroIntroBoxOuter">
                      <div className="heroIntroBox">
                          <span className="issueId">{this.props.state.loadedIssue.issueTitle}</span>
                          <h2 className="issueTitle h1">{theBlock.blockTitle}</h2>
                          <div className="issueSummary" dangerouslySetInnerHTML={{__html: theBlock.blockSummary}}/>
                          <div className="issueSummaryMore" dangerouslySetInnerHTML={{__html: theBlock.blockFooter}} />
                      </div>
                      <div className="heroIntroBoxFooter">
                        <a className="btn btn-primary read-more"  onClick={() => {this.props.changeRoute(this.props.state.loadedIssue.issueId, "")}} href={'./index.html?issueid='+this.props.state.loadedIssue.issueId+"&lang="+this.props.state.locale} role="button">
                            {theBlock.moreButtonText === "" ? (<FormattedMessage id="General.readMore" defaultMessage="Read More" />) : (<span>{theBlock.moreButtonText}</span>)}
                            <span className="more-arrow"><FontAwesomeIcon icon="arrow-right" /></span>
                        </a>
                      </div>
                  </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-10 offset-md-2 my-5">
                <div className="is-image hero-image">
                    <img src={baseUrl+theBlock.blockHeroImage} alt={theBlock.blockHeroImageAlt}/>
                </div>
              </div>
            </div>
          </div>
          <div className="past-issues py-5">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <h2><FormattedMessage id="Library.pastIssues" defaultMessage="Past issues" /></h2>
                  <div className="row row-card-deck">
                    {tmpIssues}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Library;
